import React from "react";
import { translateProps } from "MODULES/shared/decorators";
import { decorators } from "@orange-marmalade/paginate-this";
import { StatusTag, StatusTags } from "MODULES/shared/components";
import { EXPORT_HOLD } from "MODULES/Receiving/constants";
import AsIs from "./AsIs";
import AccountingHold from "./AccountingHold";
import ExchangeAgreementHold from "./ExchangeAgreement";
import Cancelled from "./Cancelled";
import QCHold from "./QCHold";
import QCPreApproval from "./QCPreApproval";
import NewCompanyHold from "./NewCompanyHold";
import ExportComplianceHold from "./ExportComplianceHold";
import UnderReview from "./UnderReview";
import Shipped from "./Shipped";
import Consignment from "./Consignment";
import {
  CancelledCustomerRmaWarning,
  CustomerRmaWarning,
  ResolvedRmaWarning
} from "./RMA";

function Warnings({ loading, results, salesOrder }) {
  if (loading) return null;
  return (
    <StatusTags>
      <AsIs lineItems={results} />
      <AccountingHold />
      <Cancelled />
      <Consignment lineItems={results} />
      <ExportComplianceHold lineItems={results} />
      <QCHold lineItems={results} />
      <CancelledCustomerRmaWarning lineItems={results} />
      <CustomerRmaWarning lineItems={results} />
      <NewCompanyHold />
      <ResolvedRmaWarning lineItems={results} />
      <QCPreApproval lineItems={results} />
      <UnderReview lineItems={results} />
      <Shipped />
      {salesOrder.get(EXPORT_HOLD) && (
        <StatusTag title="Denied Party" icon="pause" />
      )}
      <ExchangeAgreementHold salesOrder={salesOrder} />
    </StatusTags>
  );
}

const withListId = translateProps(() => ({
  listId: "salesOrders/lineItems"
}));

export default withListId(decorators.tabulate(Warnings));



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Warnings/Warnings.jsx